query BranchAvedaInfo($branchId: ID!) {
  branch(branchId: $branchId) {
    id
    avedaRewardsEnabled
  }
}
